import { FlexBox } from "@styles";
import React, { CSSProperties } from "react";
import styled, { css } from "styled-components";
// import sanitize from "sanitize-html";

interface BodyProps {
  line?: number;
}

const Body = styled(FlexBox)<BodyProps>`
  gap: 1rem;
  width: 100%;
  flex-direction: column;

  ${({ line }) =>
    line &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${line};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `};

  line-height: 1.5;

  div.gac-col-resp {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 1rem;
  }

  div.article-content {
    p {
      max-width: 70ch;
      margin-top: 1.12em;
      margin-bottom: 1.12em;
    }
  }

  ul,
  ol {
    all: revert;
  }

  a {
    color: #12b8f6;
    text-decoration: underline;
  }
`;

interface RichTextProps {
  body: any;
  customStyle?: CSSProperties;
  line?: number;
  template?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RichText = ({ body, customStyle, line, template = "max-w-prose" }: RichTextProps) => {
  let wrapperClass: string;

  if (template === "prose") {
    wrapperClass = "prose  prose-slate lg:prose-xl prose-a:text-blue-600 hover:prose-a:text-blue-500";

    // eslint-disable-next-line react/no-danger
    return <article className={wrapperClass} dangerouslySetInnerHTML={{ __html: body ?? "" }} />;
  }

  if (template === "no-layout") {
    wrapperClass = "";
  } else wrapperClass = template;

  return (
    <Body
      line={line}
      style={customStyle}
      className={wrapperClass}
      dangerouslySetInnerHTML={{
        __html: body ?? "",

        // sanitize(body, {
        //     allowedTags: allowOnly?.length ? allowOnly : sanitize.defaults.allowedTags.concat(["img"]),
        //     allowedAttributes: false,
        //   }) ?? "No Content",
      }}
    />
  );
};

RichText.defaultProps = {
  customStyle: {},
  line: undefined,
};

export default RichText;
